import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function ProjectOverview() {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProject() {
      try {
        setLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/projects/${projectId}`,
          { withCredentials: true }
        );
        setProject(res.data);
      } catch (err) {
        setError("Failed to load project.");
      } finally {
        setLoading(false);
      }
    }
    fetchProject();
  }, [projectId]);

  if (loading) return <div className="p-6">Loading project...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;
  if (!project) return <div className="p-6">Project not found.</div>;

  // Flatten all assets arrays for demo (you can expand this later)
  const assets = [
    ...(project.images?.map((url) => ({ type: "Photo Image", url })) || []),
    ...(project.videos?.map((url) => ({ type: "Video", url })) || []),
  ];

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">{project.product_name || project.url}</h1>

      <p className="mb-6">{project.description}</p>

      <h2 className="text-xl font-semibold mb-4">Assets</h2>

      {assets.length === 0 ? (
        <p>No assets found yet.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {assets.map((asset, idx) => (
            <div key={idx} className="border rounded overflow-hidden">
              {asset.type === "Video" ? (
                <video
                  src={asset.url}
                  controls
                  className="w-full h-40 object-cover"
                />
              ) : (
                <img
                  src={asset.url}
                  alt={`${asset.type} ${idx + 1}`}
                  className="w-full h-40 object-cover"
                />
              )}
              <div className="p-2 text-center text-sm font-medium">
                {asset.type}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
